// extracted by mini-css-extract-plugin
export var colorSquare = "_u4-0";
export var danger = "_u4-5";
export var lightPink = "_u4-8";
export var neutralBlue = "_u4-7";
export var neutralYellow = "_u4-6";
export var normal = "_u4-1";
export var primary = "_u4-2";
export var primaryLight = "_u4-3";
export var solidBlack = "_u4-g";
export var solidGreen = "_u4-b";
export var solidLightBlue = "_u4-d";
export var solidNavy = "_u4-c";
export var solidOrange = "_u4-f";
export var solidPink = "_u4-e";
export var solidRed = "_u4-9";
export var solidYellow = "_u4-a";
export var success = "_u4-4";